// extracted by mini-css-extract-plugin
export var badge = "mediaCard-module--badge--c766f";
export var badges = "mediaCard-module--badges--1b8b7";
export var buttons = "mediaCard-module--buttons--1327f";
export var dark = "mediaCard-module--dark--060a4";
export var headline = "mediaCard-module--headline--682d7";
export var icon = "mediaCard-module--icon--b0ac1";
export var image = "mediaCard-module--image--477a6";
export var light = "mediaCard-module--light--d0e87";
export var logo = "mediaCard-module--logo--882ac";
export var mediaCard = "mediaCard-module--mediaCard--fc7aa";
export var videoImageContainer = "mediaCard-module--videoImageContainer--a1573";